import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AiAgentFlowService } from 'src/app/private/services/ai-agent-flow.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ai-agent-flows',
  templateUrl: './ai-agent-flows.component.html',
  styleUrls: ['./ai-agent-flows.component.scss'],
})
export class AiAgentFlowsComponent implements OnInit {

  flows: any[]  = [];
  totalRows     = 0;
  currentPage   = 0;
  pageSize      = 25;
  loading       = true;
  btnLoading    = false;
  searchQuery   = new FormControl('');

  selectedFlow: any = null;
  isAdmin = false;

  @ViewChild('formModal') formModal!: TemplateRef<any>;
  @ViewChild('deleteModal') deleteModal!: TemplateRef<any>;
  @ViewChild('testModal') testModal!: TemplateRef<any>;

  testPhoneControl = new FormControl('');

  constructor(
    private service: AiAgentFlowService,
    private modal: NgbModal,
    private toast: ToastrService,
    private ls: LocalStorageService,
  ) {}

  ngOnInit() {
    this.isAdmin = this.ls.checkFullAccessForTableList(this.ls.getRole());
    this.loadFlows();
    this.searchQuery.valueChanges.subscribe(() => this.loadFlows(true));
  }

  loadFlows(resetPage = false) {
    if (resetPage) this.currentPage = 0;
    this.loading = true;

    const payload: any = {
      client_id: this.ls.getClientId(),
      page:  this.currentPage * this.pageSize,
      limit: this.pageSize,
      search: this.searchQuery.value || '',
    };

    this.service.list(payload).subscribe({
      next: (res: any) => {
        this.flows    = res.rows ?? [];
        this.totalRows = res.count ?? 0;
        this.loading  = false;
      },
      error: () => { this.loading = false; },
    });
  }

  openCreate() {
    this.selectedFlow = null;
    this.modal.open(this.formModal, { size: 'xl', scrollable: true, centered: true });
  }

  openEdit(flow: any) {
    this.selectedFlow = { ...flow };
    this.modal.open(this.formModal, { size: 'xl', scrollable: true, centered: true });
  }

  openDelete(flow: any) {
    this.selectedFlow = flow;
    this.modal.open(this.deleteModal, { size: 'sm', centered: true });
  }

  onFormSaved() {
    this.modal.dismissAll();
    this.loadFlows();
    this.toast.success('AI Agent Flow saved successfully');
  }

  confirmDelete() {
    if (!this.selectedFlow?.id) return;
    this.btnLoading = true;
    this.service.delete({ id: this.selectedFlow.id }).subscribe({
      next: () => {
        this.btnLoading = false;
        this.modal.dismissAll();
        this.loadFlows();
        this.toast.success('Flow deleted');
      },
      error: () => { this.btnLoading = false; this.toast.error('Delete failed'); },
    });
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize    = event.pageSize;
    this.loadFlows();
  }

  openTest(flow: any) {
    this.selectedFlow = flow;
    this.testPhoneControl.setValue('');
    this.modal.open(this.testModal, { windowClass: 'test-flow-modal-custom', centered: true });
  }

  confirmTest() {
    if (!this.testPhoneControl.value || !this.selectedFlow) return;
    this.btnLoading = true;
    
    const payload = {
      customer_number: this.testPhoneControl.value,
      customer_name: "Test User",
      customer_email: "test@test.com",
      use_streaming: false,
      timezone: "Asia/Kolkata",
      mode: environment.production ? "prod" : "dev",
      platform_type: "crm",
      conversation_flow_id: this.selectedFlow.id,
      last_updated_date_time: this.selectedFlow?.updated_at || this.selectedFlow?.updatedAt || new Date().toISOString(),
      campaign_id: 1,
      client_id: this.ls.getClientId(),
      client_name: "Test Client",
      centre_id: 1,
      center_id: 1
    };

    this.service.testFlow(payload).subscribe({
      next: () => {
        this.btnLoading = false;
        this.modal.dismissAll();
        this.toast.success('Test call initiated successfully!');
      },
      error: () => {
        this.btnLoading = false;
        this.toast.error('Failed to initiate test call');
      }
    });
  }
}
